import { __extends } from "tslib";
import * as React from 'react';
import * as shape from 'd3-shape';
import { classNamesFunction, getRTL } from '@fluentui/react/lib/Utilities';
import { getStyles } from './Arc.styles';
import { format as d3Format, formatPrefix as d3FormatPrefix } from 'd3-format';
var Arc = /** @class */ (function (_super) {
    __extends(Arc, _super);
    function Arc() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.currentRef = React.createRef();
        _this._isRTL = getRTL();
        _this._hoverOff = function () {
            _this.props.hoverLeaveCallback();
        };
        _this._onBlur = function () {
            _this.props.onBlurCallback();
        };
        _this._getAriaLabel = function () {
            var _a;
            var point = _this.props.data.data;
            var legend = point.xAxisCalloutData || point.legend;
            var yValue = point.yAxisCalloutData || point.data || 0;
            return ((_a = point.callOutAccessibilityData) === null || _a === void 0 ? void 0 : _a.ariaLabel) || (legend ? legend + ", " : '') + (yValue + ".");
        };
        _this._renderArcLabel = function (className) {
            var _a = _this.props, arc = _a.arc, data = _a.data, innerRadius = _a.innerRadius, outerRadius = _a.outerRadius, showLabelsInPercent = _a.showLabelsInPercent, totalValue = _a.totalValue, hideLabels = _a.hideLabels;
            if (hideLabels || Math.abs(data.endAngle - data.startAngle) < Math.PI / 12) {
                return null;
            }
            var _b = arc.centroid(data), base = _b[0], perp = _b[1];
            var hyp = Math.sqrt(base * base + perp * perp);
            var labelRadius = Math.max(innerRadius, outerRadius) + 2;
            var angle = (data.startAngle + data.endAngle) / 2;
            var arcValue = data.value;
            return (React.createElement("text", { x: (hyp === 0 ? 0 : base / hyp) * labelRadius, y: (hyp === 0 ? 0 : perp / hyp) * labelRadius, textAnchor: angle > Math.PI !== _this._isRTL ? 'end' : 'start', dominantBaseline: angle > Math.PI / 2 && angle < (3 * Math.PI) / 2 ? 'hanging' : 'auto', className: className, "aria-hidden": true }, showLabelsInPercent
                ? d3Format('.0%')(totalValue === 0 ? 0 : arcValue / totalValue)
                : d3FormatPrefix(arcValue < 1000 ? '.2~' : '.1', arcValue)(arcValue)));
        };
        return _this;
    }
    Arc.getDerivedStateFromProps = function (nextProps) {
        _updateChart(nextProps);
        return null;
    };
    Arc.prototype.updateChart = function (newProps) {
        _updateChart(newProps);
    };
    Arc.prototype.render = function () {
        var _a;
        var _b = this.props, arc = _b.arc, href = _b.href, focusedArcId = _b.focusedArcId;
        var getClassNames = classNamesFunction();
        var classNames = getClassNames(getStyles, {
            color: this.props.color,
            href: href,
            theme: this.props.theme,
        });
        var id = this.props.uniqText + this.props.data.data.legend.replace(/\s+/, '') + this.props.data.data.data;
        var opacity = this.props.activeArc === this.props.data.data.legend || this.props.activeArc === '' ? 1 : 0.1;
        return (React.createElement("g", { ref: this.currentRef },
            !!focusedArcId && focusedArcId === id && (React.createElement("path", { id: id + 'focusRing', d: arc(this.props.focusData), className: classNames.focusRing })),
            React.createElement("path", { id: id, d: arc(this.props.data), onFocus: this._onFocus.bind(this, this.props.data.data, id), className: classNames.root, "data-is-focusable": true, onMouseOver: this._hoverOn.bind(this, this.props.data.data), onMouseMove: this._hoverOn.bind(this, this.props.data.data), onMouseLeave: this._hoverOff, onBlur: this._onBlur, opacity: opacity, onClick: href ? this._redirectToUrl.bind(this, href) : (_a = this.props.data) === null || _a === void 0 ? void 0 : _a.data.onClick, "aria-label": this._getAriaLabel(), role: "img" }),
            this._renderArcLabel(classNames.arcLabel)));
    };
    Arc.prototype._onFocus = function (data, id) {
        this.props.onFocusCallback(data, id, this.currentRef.current);
    };
    Arc.prototype._hoverOn = function (data, mouseEvent) {
        mouseEvent.persist();
        this.props.hoverOnCallback(data, mouseEvent);
    };
    Arc.prototype._redirectToUrl = function (href) {
        href ? (window.location.href = href) : '';
    };
    Arc.defaultProps = {
        arc: shape.arc(),
    };
    return Arc;
}(React.Component));
export { Arc };
function _updateChart(newProps) {
    newProps.arc.innerRadius(newProps.innerRadius);
    newProps.arc.outerRadius(newProps.outerRadius);
}
//# sourceMappingURL=Arc.js.map